export default "__VITE_ASSET__5fb05c19__"